import axios from 'axios';
import { Crosstab } from '@hotjar/webapp/utils/crosstab';

/**
 * Sets the recording as watched and triggers a Crosstab signal
 * (which marks the recording as watched in the recordings list).
 */
export const setRecordingAsWatched = (siteId: number, recordingId: number): void => {
  axios
    .post(`/api/v1/sites/${siteId}/recordings/${recordingId}`, {
      action: 'set_watched',
    })
    .then(function () {
      Crosstab.signal('watchingRecording', { recordingId }, false);
    });
};
